import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

export const Title = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.ExpenseClaim);

  return (
    <Stack alignItems='center' gap='12px' mb='8px'>
      <Typography component='h1' tabIndex={0} variant='h2'>
        {dictionary.title}
      </Typography>
      <Typography variant='body3'>{dictionary.subtitle}</Typography>
    </Stack>
  );
};
